module.exports = __webpack_public_path__ + "static/media/DSC03534.42bfaa47.JPG";